<template>
    <author-about :author="author"></author-about>

    <author-news :news="news" v-if="news.length > 0"></author-news>
</template>

<script>
import bodyRefresh  from '@core/assets/js/modules/body.refresh'
import Admin        from '@admin/mixins/_Admin'
import _Page        from '@core/vuejs/templates/mixins/_Page'
import Preload      from '@app/templates/vuejs/components/_partials/Preload'

export default {
  name: "AuthorPage",
  components: {Preload},
  mixins: [_Page, Admin],
  data: function() {
    return {
      loading: false,
      blocksStorage: []
    };
  },
  async serverPrefetch () {
    let url = (this.$route.path !== "/") ? this.$route.path.replace('autores', 'authors') : '/home'
    await this.$store.dispatch("section/fetchPage", url)
  },
  computed: {
    page: function () {
      return this.$store.getters["section/page"];
    },
    news: function () {
      return this.page.content.news;
    },
    author: function () {
      return this.page.content.authorProfile;
    }
  }
}
</script>
